/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CreateNewProfessionalModal/Details/Person/Profession/Content",
  onChange
  
}) {
let professionsValueData = fromData.useDataValue({ viewPath,
context: 'professions',
})
let newProfessionalOtherEmployeeTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'new_professional',
path: 'other.employee_type.id',
})
let newProfessionalOtherEmployeeTypeIdChangeData = fromData.useDataChange({ viewPath,
context: 'new_professional',
path: 'other.employee_type.id',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 allowEmptyChoice={false}
 size="medium"
 data="professions"
 from={professionsValueData}
 data="new_professional.other.employee_type.id"
 value={newProfessionalOtherEmployeeTypeIdValueData}
 onChange={newProfessionalOtherEmployeeTypeIdChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Profession"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}